import { render } from "./StoreInfo.vue?vue&type=template&id=36f676fc&scoped=true"
import script from "./StoreInfo.vue?vue&type=script&lang=js"
export * from "./StoreInfo.vue?vue&type=script&lang=js"

import "./StoreInfo.vue?vue&type=style&index=0&id=36f676fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f676fc"]])

export default __exports__